import React, {FC, InputHTMLAttributes} from 'react';
import classes from './HLFormInput.module.scss'

interface HLFormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  error?: string;
}

const HLFormInput: FC<HLFormInputProps> = ({id, error, children, ...props}) => {
  return (
      <div className={`${classes.inputGroup} ${error ? classes.error : ''}`} >
        {children && <label className={classes.inputLabel} htmlFor={id}>{children}</label>}
        <input
            className={`${classes.inputField} ${error ? classes.error : ''}`}
            id={id}
            {...props}
        />
        {error && <div className={classes.errorMessage}>{error}</div>}
      </div>
  );
};

export default HLFormInput;